exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cms-grid{display:grid;grid-column-gap:20px;grid-template-columns:repeat(16,1fr)}.cms-grid-item--g3{grid-column:span 3}.cms-grid-item--g4{grid-column:span 4}.cms-grid-item--g5{grid-column:span 5}.cms-grid-item--g6{grid-column:span 6}.cms-grid-item--g8{grid-column:span 8}.cms-grid-item--g12{grid-column:span 12}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f68a531c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/pages/PageNeighborhood.vue
// module id = tCEJ
// module chunks = 0 1